import { ChangeDetectionStrategy, Component, computed, ElementRef, inject, input, output } from '@angular/core';
import { CalendarEvent } from '@modules/calendar-app/types/calendar-event';
import { DisplayTimeZoneService } from '@modules/common/services/display-timezone.service';
import { toDisplayZoneWallClock } from '@modules/full-calendar/types/display-timezone-format';
import { PopoverDirective } from '@frontendlib/components/features/popover/directives/popover.directive';
import { type MonthViewDay } from 'calendar-utils';
import { Subject } from 'rxjs';
import { CalendarMonthSmallCellComponent } from '../calendar-month-small-cell/calendar-month-small-cell.component';
import { EventsListPopupComponent } from '../events-list/events-list-popup.component';

@Component({
  standalone: true,
  selector: 'stch-calendar-year-day-cell',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './calendar-year-day-cell.component.html',
  imports: [PopoverDirective, CalendarMonthSmallCellComponent, EventsListPopupComponent],
})
export class CalendarYearDayCellComponent {
  public readonly day = input.required<MonthViewDay>();
  public readonly selected = input<boolean>(false);
  public readonly popupDisabled = input<boolean>(false);
  protected readonly eventClicked = output<CalendarEvent>();
  protected readonly eventDblClicked = output<CalendarEvent>();

  protected readonly events = computed(() => this.day().events.map((event) => event.meta));

  public readonly elementRef = inject(ElementRef);
  private readonly displayTimeZoneService = inject(DisplayTimeZoneService);

  // SBUX-829: display the "more events" popup date in the display (account) zone, matching the cell.
  protected readonly displayDate = computed(() =>
    toDisplayZoneWallClock(this.day().date, this.displayTimeZoneService.timeZone()),
  );

  protected readonly popoverClose = new Subject<void>();
}
